/**
 * 경로 → 그 화면의 lazy 청크를 미리 받는 함수. `App.tsx` 가 등록하고, 공개 레이아웃이
 * 링크에 마우스·포커스가 닿을 때 불러 둔다 — 페이지 전환 애니메이션이 청크를 기다리지 않게.
 * (레이아웃이 App 을 직접 import 하면 순환이 생겨서 이 작은 저장소를 사이에 둔다.)
 */
const loaders = new Map<string, () => Promise<unknown>>();

export function registerPreload(path: string, load: () => Promise<unknown>): void {
  loaders.set(path, load);
}

export function preloadRoute(path: string): void {
  const load = loaders.get(path);
  if (load) void load().catch(() => {});
}
